(function () {
  'use strict';

  var integer = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });
  var oneDecimal = new Intl.NumberFormat('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  var SVG_NS = 'http://www.w3.org/2000/svg';

  function finite(value) {
    return typeof value === 'number' && Number.isFinite(value);
  }

  function validSummary(summary) {
    return summary && finite(summary.q25) && finite(summary.median) && finite(summary.q75) &&
      summary.q25 >= 0 && summary.q25 <= summary.median && summary.median <= summary.q75;
  }

  function validBand(band) {
    return band && band.id && band.label && Number.isSafeInteger(band.distinctPrograms) && band.distinctPrograms > 0 &&
      validSummary(band.usageMonthlyPairs) && validSummary(band.lotPairs) &&
      validSummary(band.coverageWeeks) && validSummary(band.cadenceDays);
  }

  function validStage(stage) {
    return stage && stage.id && stage.label && Number.isSafeInteger(stage.distinctPrograms) &&
      stage.distinctPrograms > 0 && validSummary(stage.coverageWeeks);
  }

  function read(root) {
    var node = root.querySelector('[data-ers-recurring-program-model]');
    if (!node) return null;
    try {
      var data = JSON.parse(node.textContent);
      if (!data || !data.population || !Number.isSafeInteger(data.population.distinctPrograms) || data.population.distinctPrograms <= 0) return null;
      if (!Array.isArray(data.usageBands) || data.usageBands.length < 2 || data.usageBands.some(function (band) { return !validBand(band); })) return null;
      if (!Array.isArray(data.maturation) || data.maturation.length < 2 || data.maturation.some(function (stage) { return !validStage(stage); })) return null;
      return data;
    } catch (error) {
      return null;
    }
  }

  function node(name, className, text) {
    var result = document.createElement(name);
    if (className) result.className = className;
    if (text !== undefined) result.textContent = text;
    return result;
  }

  function svgNode(name, attributes) {
    var result = document.createElementNS(SVG_NS, name);
    Object.keys(attributes || {}).forEach(function (key) { result.setAttribute(key, String(attributes[key])); });
    return result;
  }

  function formatWeeks(value) {
    return oneDecimal.format(value) + (value === 1 ? ' week' : ' weeks');
  }

  function formatWeekRange(summary) {
    return oneDecimal.format(summary.q25) + '–' + oneDecimal.format(summary.q75) + ' weeks';
  }

  function formatDays(value) {
    return integer.format(Math.round(value)) + (Math.round(value) === 1 ? ' day' : ' days');
  }

  function definition(term, value, detail) {
    var wrapper = node('div', 'ers-program-metric');
    wrapper.appendChild(node('dt', '', term));
    var description = node('dd', '', value);
    if (detail) description.appendChild(node('small', '', detail));
    wrapper.appendChild(description);
    return wrapper;
  }

  function coverageMaximum(data) {
    var values = data.usageBands.map(function (band) { return band.coverageWeeks.q75; });
    return Math.max(1, Math.ceil(Math.max.apply(Math, values)));
  }

  function relationshipRow(band, maximum) {
    var item = node('li', 'ers-program-relationship__row');
    item.tabIndex = 0;
    item.setAttribute('data-program-band', band.id);

    var heading = node('div', 'ers-program-relationship__label');
    heading.appendChild(node('strong', '', band.label));
    heading.appendChild(node('span', '', 'About ' + integer.format(Math.round(band.usageMonthlyPairs.median)) + ' pairs/month'));
    heading.appendChild(node('small', '', 'n=' + integer.format(band.distinctPrograms) + ' recurring programs'));
    item.appendChild(heading);

    var coverage = node('div', 'ers-program-relationship__coverage');
    var track = node('div', 'ers-program-relationship__track');
    track.setAttribute('aria-hidden', 'true');
    var range = node('i', 'ers-program-relationship__range');
    range.style.left = (band.coverageWeeks.q25 / maximum * 100) + '%';
    range.style.width = ((band.coverageWeeks.q75 - band.coverageWeeks.q25) / maximum * 100) + '%';
    var marker = node('b', 'ers-program-relationship__median');
    marker.style.left = (band.coverageWeeks.median / maximum * 100) + '%';
    track.appendChild(range);
    track.appendChild(marker);
    coverage.appendChild(track);
    coverage.appendChild(node('span', '', 'Middle 50%: ' + formatWeekRange(band.coverageWeeks)));
    item.appendChild(coverage);

    var metrics = node('dl', 'ers-program-relationship__metrics');
    metrics.appendChild(definition('Inventory coverage', formatWeeks(band.coverageWeeks.median), 'modeled median'));
    metrics.appendChild(definition('Fulfilled lot', integer.format(Math.round(band.lotPairs.median)) + ' pairs', 'median'));
    metrics.appendChild(definition('Reorder cadence', formatDays(band.cadenceDays.median), 'modeled median'));
    item.appendChild(metrics);
    return item;
  }

  function drawRelationship(root, data) {
    var body = root.querySelector('[data-program-relationship-body]');
    if (!body) return;
    body.textContent = '';
    var list = node('ol', 'ers-program-relationship__rows');
    list.setAttribute('aria-label', 'Recurring-program usage, fulfilled lot, inventory coverage and reorder cadence by estimated usage band');
    var maximum = coverageMaximum(data);
    data.usageBands.forEach(function (band) { list.appendChild(relationshipRow(band, maximum)); });
    body.appendChild(list);
  }

  function point(stage, index, count, field, width, height, margin, maximum) {
    var x = margin.left + (count === 1 ? 0 : index / (count - 1) * (width - margin.left - margin.right));
    var y = margin.top + (1 - stage.coverageWeeks[field] / maximum) * (height - margin.top - margin.bottom);
    return { x: x, y: y };
  }

  function path(points, close) {
    if (!points.length) return '';
    return points.map(function (value, index) { return (index ? 'L' : 'M') + value.x.toFixed(2) + ',' + value.y.toFixed(2); }).join(' ') + (close ? ' Z' : '');
  }

  function drawMaturationChart(root, data) {
    var target = root.querySelector('[data-program-maturation-chart]');
    if (!target) return;
    target.textContent = '';

    var width = 720;
    var height = 272;
    var margin = { top: 22, right: 22, bottom: 48, left: 54 };
    var maximum = Math.max(1, Math.ceil(Math.max.apply(Math, data.maturation.map(function (stage) { return stage.coverageWeeks.q75; }))));
    var svg = svgNode('svg', { viewBox: '0 0 ' + width + ' ' + height, role: 'img', 'aria-label': 'Median and middle 50 percent of modeled inventory coverage by recurring-program order stage' });

    [0, maximum / 2, maximum].forEach(function (tick) {
      var y = margin.top + (1 - tick / maximum) * (height - margin.top - margin.bottom);
      svg.appendChild(svgNode('line', { x1: margin.left, y1: y, x2: width - margin.right, y2: y, class: 'ers-program-maturation__gridline' }));
      var label = svgNode('text', { x: margin.left - 10, y: y + 4, class: 'ers-program-maturation__tick', 'text-anchor': 'end' });
      label.textContent = oneDecimal.format(tick);
      svg.appendChild(label);
    });

    var upper = data.maturation.map(function (stage, index) { return point(stage, index, data.maturation.length, 'q75', width, height, margin, maximum); });
    var lower = data.maturation.map(function (stage, index) { return point(stage, index, data.maturation.length, 'q25', width, height, margin, maximum); }).reverse();
    var medians = data.maturation.map(function (stage, index) { return point(stage, index, data.maturation.length, 'median', width, height, margin, maximum); });
    svg.appendChild(svgNode('path', { d: path(upper.concat(lower), true), class: 'ers-program-maturation__band' }));
    svg.appendChild(svgNode('path', { d: path(medians, false), class: 'ers-program-maturation__line' }));

    medians.forEach(function (coordinate, index) {
      var stage = data.maturation[index];
      var group = svgNode('g', { class: 'ers-program-maturation__point', 'data-stage-point': stage.id });
      var title = svgNode('title');
      title.textContent = stage.label + ': median ' + formatWeeks(stage.coverageWeeks.median) + ', middle 50% ' + formatWeekRange(stage.coverageWeeks) + ', n=' + integer.format(stage.distinctPrograms);
      group.appendChild(title);
      group.appendChild(svgNode('circle', { cx: coordinate.x, cy: coordinate.y, r: 5 }));
      var label = svgNode('text', { x: coordinate.x, y: height - 17, class: 'ers-program-maturation__stage-label', 'text-anchor': 'middle' });
      label.textContent = stage.label;
      group.appendChild(label);
      svg.appendChild(group);
    });

    var axisLabel = svgNode('text', { x: 13, y: height / 2, class: 'ers-program-maturation__axis-label', transform: 'rotate(-90 13 ' + (height / 2) + ')', 'text-anchor': 'middle' });
    axisLabel.textContent = 'Weeks of inventory coverage';
    svg.appendChild(axisLabel);
    target.appendChild(svg);
  }

  function drawMaturationDetails(root, data) {
    var body = root.querySelector('[data-program-maturation-body]');
    if (!body) return;
    body.textContent = '';
    var list = node('ol', 'ers-program-maturation__stages');
    list.setAttribute('aria-label', 'Inventory-coverage summary by recurring-program order stage');

    data.maturation.forEach(function (stage) {
      var item = node('li', 'ers-program-maturation__stage');
      item.tabIndex = 0;
      item.setAttribute('data-stage-card', stage.id);
      item.appendChild(node('strong', '', stage.label));
      var summary = node('dl', '');
      summary.appendChild(definition('Median coverage', formatWeeks(stage.coverageWeeks.median)));
      summary.appendChild(definition('Middle 50%', formatWeekRange(stage.coverageWeeks)));
      summary.appendChild(definition('Programs', 'n=' + integer.format(stage.distinctPrograms)));
      item.appendChild(summary);

      var activate = function () {
        root.querySelectorAll('[data-stage-card], [data-stage-point]').forEach(function (element) { element.classList.remove('is-active'); });
        item.classList.add('is-active');
        var pointNode = root.querySelector('[data-stage-point="' + stage.id + '"]');
        if (pointNode) pointNode.classList.add('is-active');
      };
      var deactivate = function () {
        item.classList.remove('is-active');
        var pointNode = root.querySelector('[data-stage-point="' + stage.id + '"]');
        if (pointNode) pointNode.classList.remove('is-active');
      };
      item.addEventListener('mouseenter', activate);
      item.addEventListener('mouseleave', deactivate);
      item.addEventListener('focus', activate);
      item.addEventListener('blur', deactivate);
      list.appendChild(item);
    });
    body.appendChild(list);
  }

  function unavailable(root) {
    root.classList.add('is-data-unavailable');
    root.querySelectorAll('.ers-program-figure__loading').forEach(function (message) {
      message.textContent = 'The recurring-program aggregate is temporarily unavailable.';
    });
  }

  function initialize(root) {
    var data = read(root);
    if (!data) {
      unavailable(root);
      return;
    }
    drawRelationship(root, data);
    if (root.querySelector('[data-ers-program-maturation]')) {
      drawMaturationChart(root, data);
      drawMaturationDetails(root, data);
    }
    root.setAttribute('data-evidence-state', 'ready');
  }

  function initializeAll() {
    document.querySelectorAll('[data-ers-program-evidence]').forEach(initialize);
  }

  window.ERSRecurringProgramVisuals = { initialize: initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
  else initializeAll();
}());
